/* Holy Gels bundle direct: cart display name.
   1. When the kit page adds an Essentials / Plus / Maxi bundle line, the line also gets the
      property _kit_sets (2, 3 or 4). Only the number is stored, so no label text reaches
      checkout, the order or Recharge.
   2. The UpCart drawer shows a name built here from that number: the tier's "cart name" from
      the section settings when this page has it, otherwise "Holy Gels Starter Kit - N Sets".
      Only lines that carry _kit_sets change; gift lines and every other line keep their own
      name. The theme cart page builds the same name in snippets/cart-line-items.liquid. */
(function (window, document) {
  "use strict";
  if (window.__hgDisplayTitle) return;
  window.__hgDisplayTitle = true;

  var PROP = "_kit_sets";
  var STORE_KEY = "hg_kit_sets_labels";
  var ORIGINAL = "data-hg-original-title";

  /* ---------- labels known for this cart: "variant|plan" -> [label per line, in cart order] ---------- */
  var labels = readStore();
  var byLineKey = {};
  var pending = {}; /* "variant|plan" -> { label, t } seeded at add time, kept until the cart shows the line */

  function readStore() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function writeStore() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(labels));
    } catch (e) {}
  }

  /* "N" -> label, from the bundle groups on this page (section setting), else the default pattern */
  function labelFor(sets) {
    var n = String(sets == null ? "" : sets).trim();
    if (!/^\d{1,2}$/.test(n)) return "";
    var group = document.querySelector('.bundle-group[data-kit-sets="' + n + '"][data-display-title]');
    return (group && group.getAttribute("data-display-title")) || "Holy Gels Starter Kit - " + n + " Sets";
  }

  function keyOf(variantId, planId) {
    return String(variantId || "") + "|" + String(planId || "");
  }

  function setFromCart(cart) {
    var next = {};
    byLineKey = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : "";
      var label = item.properties ? labelFor(item.properties[PROP]) : "";
      var k = keyOf(item.variant_id, plan);
      (next[k] = next[k] || []).push(label);
      if (label) byLineKey[item.key] = label;
    });
    /* A cart read that started before the add finished must not drop the label just seeded. */
    Object.keys(pending).forEach(function (k) {
      var seed = pending[k];
      if ((next[k] || []).indexOf(seed.label) !== -1 || Date.now() - seed.t > 30000) {
        delete pending[k];
      } else {
        (next[k] = next[k] || []).push(seed.label);
      }
    });
    labels = next;
    writeStore();
    applyAll();
  }

  var cartRequest = null;
  function refreshFromCart() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { if (cart) setFromCart(cart); })
      .catch(function () {})
      .then(function () { cartRequest = null; });
    return cartRequest;
  }

  /* ---------- 1. add the property when the kit adds a bundle line ---------- */
  function wrapShared(api) {
    if (!api || api.__hgDisplayTitle || typeof api.buildRechargeBundleLineItem !== "function") return api;
    var original = api.buildRechargeBundleLineItem;
    api.buildRechargeBundleLineItem = function (options) {
      return Promise.resolve(original.apply(this, arguments)).then(function (result) {
        try {
          var group = options && options.groupEl;
          var sets = group && group.getAttribute("data-kit-sets");
          var label = labelFor(sets);
          var item = result && result.parentItem;
          if (item && label && options.isSubscription !== false) {
            item.properties = item.properties || {};
            item.properties[PROP] = String(sets);
            /* Known before UpCart renders the new line, so the drawer never paints the old name. */
            var k = keyOf(item.id, item.selling_plan);
            (labels[k] = labels[k] || []).push(label);
            pending[k] = { label: label, t: Date.now() };
            writeStore();
          }
        } catch (e) {}
        return result;
      });
    };
    api.__hgDisplayTitle = true;
    return api;
  }

  if (window.BundleSharedV1) {
    wrapShared(window.BundleSharedV1);
  } else {
    var shared;
    try {
      Object.defineProperty(window, "BundleSharedV1", {
        configurable: true,
        enumerable: true,
        get: function () { return shared; },
        set: function (value) { shared = wrapShared(value); },
      });
    } catch (e) {}
  }

  /* ---------- 2. relabel ---------- */
  function firstTextNode(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; },
    });
    return walker.nextNode();
  }

  function setText(el, label) {
    if (!el) return;
    var node = firstTextNode(el);
    if (!node) return;
    var current = node.nodeValue.trim();
    if (current === label) return;
    if (!el.hasAttribute(ORIGINAL)) el.setAttribute(ORIGINAL, current);
    /* Change the node UpCart owns, so its next render overwrites this same node and we see it. */
    node.nodeValue = node.nodeValue.replace(current, label);
  }

  function paramsOf(href) {
    try {
      var u = new URL(href, location.origin);
      return { variant: u.searchParams.get("variant") || "", plan: u.searchParams.get("selling_plan") || "" };
    } catch (e) {
      return { variant: "", plan: "" };
    }
  }

  /* UpCart drawer: each li.upcart-public-cart-item links to /products/x?selling_plan=P&variant=V */
  function applyUpCart(root) {
    var seen = {};
    root.querySelectorAll("li.upcart-public-cart-item").forEach(function (li) {
      var link = li.querySelector(".upcart-public-component-product-tile__title-link");
      if (!link) return;
      var q = paramsOf(link.getAttribute("href"));
      var k = keyOf(q.variant, q.plan);
      var n = seen[k] = (seen[k] || 0) + 1;
      var label = labels[k] && labels[k][n - 1];
      if (!label) return;
      setText(link, label);
      var remove = li.querySelector(".upcart-public-component-product-tile__remove-button");
      if (remove) remove.setAttribute("aria-label", "Remove " + label);
      var img = li.querySelector(".upcart-public-component-product-tile__image");
      if (img && img.getAttribute("alt") !== label) img.setAttribute("alt", label);
    });
  }

  /* Theme cart page and theme drawer: [data-cart-item] rows from snippets/cart-line-items.liquid */
  function applyThemeCart() {
    document.querySelectorAll("[data-cart-item][data-item]").forEach(function (row) {
      var label = byLineKey[row.getAttribute("data-item")];
      if (!label) return;
      setText(row.querySelector(".cart__item__title a, .cart__item__title"), label);
      row.setAttribute("data-item-title", label);
      var img = row.querySelector(".cart__item__image img");
      if (img) img.setAttribute("alt", label);
    });
  }

  var upRoot = null;
  function applyAll() {
    if (upRoot) applyUpCart(upRoot);
    applyThemeCart();
  }

  /* Watch the UpCart shadow root. MutationObserver callbacks run before the next paint, so a
     re render that writes the real name back is relabelled in the same frame. */
  var lastSignature = "";
  function signature(root) {
    var parts = [];
    root.querySelectorAll("li.upcart-public-cart-item .upcart-public-component-product-tile__title-link").forEach(function (a) {
      parts.push(a.getAttribute("href"));
    });
    return parts.join(",");
  }

  function attachUpCart() {
    var host = document.getElementById("upCart");
    var root = host && host.shadowRoot;
    if (!root || root === upRoot) return !!root;
    upRoot = root;
    new MutationObserver(function () {
      applyUpCart(root);
      var sig = signature(root);
      if (sig !== lastSignature) {
        lastSignature = sig;
        refreshFromCart();
      }
    }).observe(root, { subtree: true, childList: true, characterData: true });
    applyUpCart(root);
    return true;
  }

  /* UpCart loads after the first interaction on these pages, so keep looking for it for a while. */
  var tries = 0;
  var timer = setInterval(function () {
    if (attachUpCart() || ++tries > 600) clearInterval(timer);
  }, 200);

  function start() {
    applyThemeCart();
    var cartRoot = document.querySelector("[data-cart-form], form[action='/cart'], .cart");
    if (cartRoot && window.MutationObserver) {
      new MutationObserver(applyThemeCart).observe(cartRoot, { subtree: true, childList: true, characterData: true });
    }
    refreshFromCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  window.HGDisplayTitle = { refresh: refreshFromCart, apply: applyAll };
})(window, document);
